var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRecommFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m20.574 9.762-.466-.466a1.59 1.59 0 0 1-.463-1.12v-.655a3.164 3.164 0 0 0-3.165-3.165h-.655c-.42 0-.823-.167-1.12-.463l-.466-.466a3.165 3.165 0 0 0-4.476 0l-.466.466c-.296.296-.7.463-1.12.463h-.655a3.165 3.165 0 0 0-3.165 3.165v.655c0 .42-.167.823-.463 1.12l-.466.466a3.165 3.165 0 0 0 0 4.476l.466.466c.296.296.463.7.463 1.12v.655a3.164 3.164 0 0 0 3.165 3.165h.655c.42 0 .823.167 1.12.463l.466.466a3.165 3.165 0 0 0 4.476 0l.465-.466c.297-.296.7-.463 1.12-.463h.656a3.164 3.164 0 0 0 3.165-3.165v-.655c0-.42.167-.823.463-1.12l.466-.466a3.165 3.165 0 0 0 0-4.476",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M15.24 9.371a.444.444 0 0 1 0 .629l-4.26 4.259a.444.444 0 0 1-.628 0L8.5 12.406a.444.444 0 1 1 .629-.628l1.538 1.538L14.61 9.37a.444.444 0 0 1 .629 0",
  clipRule: "evenodd"
})));
export default SvgRecommFill;